module.exports = __webpack_public_path__ + "static/media/poi.997d1bbd.svg";